import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { catchError, first, map, of } from 'rxjs';


export const authGuard: CanActivateFn = (route, state) => {
 const authService = inject(AuthService);
   const router = inject(Router);

   console.log('authGuard');
   return authService.fetchUserRole().pipe(
      first(), // Nos aseguramos de tomar solo la primera emisión
      map(role => {
         if (role === 'user') {
            console.log('Rol: ', role);
            return true; // Permite acceso si el rol es 'user'
         }
         router.navigate(['/']); // Redirigir a la página principal o dashboard
         return false; // Bloquea acceso si el rol no es 'user'
      }),
      catchError(error => {
         if (error.status === 500) {
            console.error('No autorizado');
            router.navigate(['/login']); // Redirigir a la página de login
            return of(false); // Bloquea el acceso en caso de error 500
         } else {
            console.error('Error al obtener el rol:', error);
            router.navigate(['/error']); // Redirigir a una página de error genérica
            return of(false); // Bloquea el acceso en caso de error desconocido
         }
      })
   );
};
